export const KINDERGARTENS = '/';
export const CALLBACK = '/callback';
export const UNATHORIZED = '/unathorized';
export const INFOBOARD = '/infoboard';
export const KINDERGARTEN_DETAILS = `${KINDERGARTENS}/:kindergartenId/details`;
export const LOCATIONS_CREATE = `${KINDERGARTENS}/:kindergartenId/locations/create/:kindergartenName`;
export const GROUP_DETAILS = `${KINDERGARTENS}/:kindergartenId/groups/:groupId/details/:kindergartenName/:locationName`;
export const TEACHERS_CREATE = `${KINDERGARTENS}/:kindergartenId/teacher/create/:kindergartenName`;
export const TEACHER_EDIT = `${KINDERGARTENS}/:kindergartenId/teacher/:teacherId/edit/:kindergartenName`;
export const TEACHER_DETAILS = `${KINDERGARTENS}/:kindergartenId/teacher/:teacherId/details/:kindergartenName`;
export const CHILD_CREATE = `${KINDERGARTENS}/:kindergartenId/child/create/:kindergartenName`;
export const CHILD_EDIT = `${KINDERGARTENS}/:kindergartenId/child/:childId/edit/:kindergartenName`;
export const CHILD_DETAILS = `${KINDERGARTENS}/:kindergartenId/child/:childId/details/:kindergartenName`;
export const PARENT_CREATE = `${KINDERGARTENS}/:kindergartenId/parent/create/:kindergartenName`;
export const PARENT_EDIT = `${KINDERGARTENS}/:kindergartenId/parent/:parentId/edit/:kindergartenName`;
export const PARENT_DETAILS = `${KINDERGARTENS}/:kindergartenId/parent/:parentId/details/:kindergartenName`;
export const POST_CREATE = `${INFOBOARD}/post/create`;
export const POST_EDIT = `${INFOBOARD}/post/:postId/edit`;
export const EVENT_CREATE = `${KINDERGARTENS}/:kindergartenId/event/create/:kindergartenName`;
export const EVENT_DETAILS = `${KINDERGARTENS}/:kindergartenId/groups/:groupId/event-configuration/:kindergartenName/:locationName`;
